import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'

const Container = styled.div`
`

const IMG = styled.img`
`;

const SVG = styled.svg`
    fill: #fff;
`;

const Sponsors = () => (
    <Container>
        <div>
            <p>
                <a href="http://tech.lifeway.com/" target="_blank" rel="noopener">
                    <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 103.53 28.25">
                      <g>
                        <title>LifeWay IT</title>
                        <path d="M78.35 4.5h1.15v19.24h-1.15z" />
                        <path d="M0 0v28.25h103.53V0zm102.37 27.1H1.16V1.15h101.21z" />
                        <path d="M10.84 16.95H8.02v-6.86H6.75v7.98h4.09v-1.12zM15.86 10.09h1.27v7.98h-1.27zM24.2 14.65h2.85v-1.11H24.2v-2.33h2.89v-1.12h-4.16v7.98h1.27v-3.42zM36.8 16.95h-3.19v-2.36h3.15v-1.11h-3.15v-2.27h3.19v-1.12h-4.46v7.98h4.46v-1.12zM45.13 18.07l1.55-6.05 1.54 6.05h1.17l2.2-7.98H50.3l-1.55 6.26-1.59-6.26h-.96l-1.56 6.25-1.58-6.25h-1.29l2.16 7.98h1.2zM57.55 16.18H61l.75 1.89h1.35l-3.22-8h-1.16l-3.28 8h1.38zm1.69-4.61l1.37 3.59H57.9zM69.08 18.07h1.27v-2.83l2.5-5.15h-1.38l-1.76 3.95-1.76-3.95h-1.38l2.51 5.15v2.83zM86.25 10.09h1.27v7.98h-1.27zM94.39 18.07h1.27v-6.86h1.83v-1.12h-4.94v1.12h1.84v6.86z" />
                      </g>
                    </SVG>
                </a>
            </p>
        </div>
        <div>
            <p>
                <a href="http://dts.edu/" target="_blank" rel="noopener">
                    <IMG src="img/dts.png" alt="Dallas Theological Seminary" />
                </a>
            </p>
        </div>
    </Container>
);

export default Sponsors



// WEBPACK FOOTER //
// ./src/components/sponsors.js